import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const EditColumnsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "EditColumns",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.37 5.11H5.63C3.63 5.11 2 6.74 2 8.74v14.52c0 2 1.63 3.63 3.63 3.63h20.74c2 0 3.63-1.63 3.63-3.63V8.74c0-2-1.63-3.63-3.63-3.63M5.11 23.26V12.37h9.33v11.41H5.63c-.29 0-.52-.23-.52-.52m21.78 0c0 .29-.23.52-.52.52h-8.82V12.37h9.33v10.89Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M4.43 27.71H3.29c-1.89 0-3.43-1.54-3.43-3.43v-1.14a1.14 1.14 0 1 1 2.28 0v1.14c0 .63.51 1.14 1.14 1.14h1.14a1.14 1.14 0 1 1 0 2.28ZM28.43 27.71h-1.14a1.14 1.14 0 1 1 0-2.28h1.14c.63 0 1.14-.51 1.14-1.14v-1.14a1.14 1.14 0 1 1 2.28 0v1.14c0 1.89-1.54 3.43-3.43 3.43ZM1 10.57c-.63 0-1.14-.51-1.14-1.14V8.29c0-1.89 1.54-3.43 3.43-3.43h1.14a1.14 1.14 0 1 1 0 2.28H3.29c-.63 0-1.14.51-1.14 1.14v1.14c0 .63-.51 1.14-1.14 1.14ZM30.71 10.57c-.63 0-1.14-.51-1.14-1.14V8.29c0-.63-.51-1.14-1.14-1.14h-1.14a1.14 1.14 0 1 1 0-2.28h1.14c1.89 0 3.43 1.54 3.43 3.43v1.14c0 .63-.51 1.14-1.14 1.14ZM30.71 19.71c-.63 0-1.14-.51-1.14-1.14V14a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M1 19.71c-.63 0-1.14-.51-1.14-1.14V14a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M13.57 27.71H9a1.14 1.14 0 1 1 0-2.28h4.57a1.14 1.14 0 1 1 0 2.28M22.71 27.71h-4.57a1.14 1.14 0 1 1 0-2.28h4.57a1.14 1.14 0 1 1 0 2.28M13.57 7.14H9a1.14 1.14 0 1 1 0-2.28h4.57a1.14 1.14 0 1 1 0 2.28M22.71 7.14h-4.57a1.14 1.14 0 1 1 0-2.28h4.57a1.14 1.14 0 1 1 0 2.28M15.86 24.29c-.63 0-1.14-.51-1.14-1.14v-4.57a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M15.86 15.14c-.63 0-1.14-.51-1.14-1.14V9.43a1.14 1.14 0 1 1 2.28 0V14c0 .63-.51 1.14-1.14 1.14"
      })
    })
  }));
};
EditColumnsIcon.displayName = 'EditColumnsIcon';